const features = [
  {
    id: 1,
    title: '海贼王完结篇特辑',
    subtitle: '热血航路最终章全收录',
    description: '草帽一伙最终冒险全话收录，51漫画免费版下载全集离线看，从第一话到完结一篇不落，永久收藏这部陪伴一代人成长的传奇之作。',
    label: '经典必藏',
    image: 'https://readdy.ai/api/search-image?query=Epic%20pirate%20adventure%20manga%20illustration%20with%20grand%20ocean%20voyage%20and%20dramatic%20sky%2C%20warm%20golden%20sunset%20tones%2C%20shonen%20manga%20art%20style%20with%20dynamic%20ship%20sailing%20composition%2C%20heroic%20atmospheric%20lighting%2C%20cinematic%20wide%20shot&width=800&height=500&seq=carousel-1&orientation=landscape',
  },
  {
    id: 2,
    title: '咒术回战激斗篇',
    subtitle: '咒术高专生死决战全收录',
    description: '虎杖悠仁与宿傩的宿命对决持续升温，51漫画下载最新话同步更新，支持离线缓存畅读全部战斗名场面，咒术粉丝不容错过。',
    label: '热门连载',
    image: 'https://readdy.ai/api/search-image?query=Dark%20supernatural%20battle%20manga%20illustration%20with%20cursed%20energy%20effects%20and%20intense%20combat%20poses%2C%20deep%20crimson%20and%20charcoal%20tones%2C%20modern%20dark%20fantasy%20manga%20style%2C%20dramatic%20action%20composition%20with%20dynamic%20movement%2C%20tense%20cinematic%20lighting&width=800&height=500&seq=carousel-2&orientation=landscape',
  },
  {
    id: 3,
    title: '鬼灭之刃无限城篇',
    subtitle: '最终决战全系列完整收录',
    description: '炭治郎与鬼杀队的最终战役完整呈现，51漫画免费版下载支持一次性获取全集，精美画风与感人剧情等你来重温每一幕经典画面。',
    label: '高画质专区',
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20Japanese%20demon%20slayer%20style%20manga%20illustration%20with%20water%20breathing%20technique%20visual%20effects%2C%20elegant%20blue%20and%20vermilion%20color%20contrast%2C%20Taisho%20era%20aesthetic%2C%20flowing%20dynamic%20composition%20with%20traditional%20Japanese%20art%20elements%2C%20emotional%20dramatic%20lighting&width=800&height=500&seq=carousel-3&orientation=landscape',
  },
  {
    id: 4,
    title: '国漫风云榜TOP50',
    subtitle: '国产漫画年度精选大合集',
    description: '精选50部年度最佳国漫作品，涵盖仙侠、都市、穿越、玄幻等全品类，51漫画下载资源一站式获取，支持批量离线缓存，国产漫画爱好者必收清单。',
    label: '国漫精选',
    image: 'https://readdy.ai/api/search-image?query=Grand%20Chinese%20manhua%20illustration%20with%20celestial%20palaces%20and%20flowing%20ink%20art%20style%2C%20warm%20vermilion%20and%20gold%20tones%2C%20epic%20Chinese%20fantasy%20landscape%20with%20floating%20mountains%2C%20traditional%20scroll%20painting%20composition%20meets%20modern%20comic%20aesthetic%2C%20majestic%20atmospheric%20lighting&width=800&height=500&seq=carousel-4&orientation=landscape',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 mb-3">
            焦点专题
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-lg mx-auto">
            精心策划的51漫画下载专题合集，热门作品一站直达
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {features.map((item) => (
            <a
              key={item.id}
              href="#index"
              className="group block bg-background-100 rounded-2xl overflow-hidden border border-background-200/60 hover:border-primary-200 transition-all cursor-pointer"
            >
              <div className="relative aspect-[16/10] overflow-hidden">
                <img
                  src={item.image}
                  alt={`${item.title} - 51漫画下载专题`}
                  className="w-full h-full object-cover object-center transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 text-xs font-medium bg-accent-500/90 text-background-50 rounded-full whitespace-nowrap">
                    {item.label}
                  </span>
                </div>
              </div>
              <div className="p-5 md:p-6">
                <p className="text-xs font-medium text-primary-600 mb-1 whitespace-nowrap">
                  {item.subtitle}
                </p>
                <h3 className="font-heading text-lg text-foreground-900 mb-2">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {item.description}
                </p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}